import {
  CDN_ASSETS_BASE_URL,
  CDN_ASSETS_PATH,
  CDN_BASE_URL,
  CDN_ORIGIN,
  CDN_PUBLIC_PATH,
  joinUrl,
} from "./appConfig";

const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/g, "");

const localCdnBase = trimTrailingSlash(CDN_PUBLIC_PATH || "/cdn");
const appAssetsBase = trimTrailingSlash(CDN_ASSETS_BASE_URL || "/cdn/assets");

const encodeAssetPath = (path = "") =>
  String(path)
    .replace(/^\/+/g, "")
    .split("/")
    .map((segment) => encodeURIComponent(segment))
    .join("/");

/** App static files under local /cdn/assets (Images, css, Fonts, …). */
export const appAssetUrl = (path = "") => {
  const encodedPath = encodeAssetPath(path);
  return encodedPath ? joinUrl(appAssetsBase, encodedPath) : appAssetsBase;
};

/**
 * Marketing / portal assets. Paths may already include the `assets/` prefix.
 * Always resolved against the local /cdn folder (src/Wlj).
 */
export const cdnAssetUrl = (path = "") => {
  const cleanPath = String(path).replace(/^\/+/g, "");
  const base = trimTrailingSlash(CDN_BASE_URL || localCdnBase);

  if (cleanPath.startsWith(`${CDN_ASSETS_PATH}/`)) {
    return joinUrl(base, encodeAssetPath(cleanPath));
  }

  return joinUrl(base, encodeAssetPath(`${CDN_ASSETS_PATH}/${cleanPath}`));
};

export const publicAssetUrl = (path = "") => {
  const cleanPath = String(path).replace(/^\/+/g, "");
  return joinUrl(localCdnBase, encodeAssetPath(cleanPath));
};

/** Sign-in left panel background (local /cdn/assets). */
export const LOGIN_BANNER_URL = appAssetUrl("Images/SignIn/wlj-login-banner.jpg");

export const FAVICON_URL = publicAssetUrl("favicon.ico");
export const APPLE_TOUCH_ICON_URL = FAVICON_URL;
export const APP_MANIFEST_URL = publicAssetUrl("manifest.json");
export const APP_LOGO_192_URL = publicAssetUrl("logo192.png");
export const APP_LOGO_512_URL = publicAssetUrl("logo512.png");
export const MESSAGE_NOTIFICATION_SOUND_URL = publicAssetUrl("wlj_msg.wav");
export const TOP_NOTIFICATION_SOUND_URL = publicAssetUrl("wlj_ntfctn.wav");
export const BELL_NOTIFICATION_SOUND_URL = publicAssetUrl("bellnotification.mp3");

export const flatpickrThemeUrl = (theme = "light") =>
  cdnAssetUrl(`vendor/flatpickr/${theme === "dark" ? "dark" : "light"}.css`);

export { CDN_ASSETS_BASE_URL, CDN_ASSETS_PATH, CDN_ORIGIN, CDN_PUBLIC_PATH };
